export * from './detect-os-dark-mode';
export * from './set-ion4-theme';
